module.exports = __webpack_public_path__ + "img/malla ondulada 3.0623309b.jpg";